module.exports = __webpack_public_path__ + "img/promocode.47f7c915.svg";